/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MergeCircleFill({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><rect width={16} height={16} fill="currentColor" rx={8} /><path fill="#fff" fillRule="evenodd" d="M5.533 6.653c.776-.183.427-.806.427-1.638 0-.971.092-1.259-.88-1.259-.97 0-1.29.288-1.29 1.26 0 .83-.235 1.454.541 1.637v5.287c0 .266.236.564.622.564.387 0 .58-.446.58-.588V9.933c.808 1.147 2.143 1.502 3.652 1.502h.318c0 .162.94-.178 1.91-.178.972 0 .865.788.865-.183s-.092-1.141-1.064-1.141c-.848 0-1.51-.36-1.51.334h-.519c-2.017 0-3.652-1.279-3.652-3.296z" clipRule="evenodd" /><path fill="#fff" d="M12.697 10.852a1.683 1.683 0 1 1-3.366 0 1.683 1.683 0 0 1 3.366 0M6.669 5.148a1.683 1.683 0 1 1-3.366 0 1.683 1.683 0 0 1 3.366 0" /><path stroke="#fff" strokeLinecap="round" d="M4.93 11.932V5.597" /></svg>;
}
;